import { render, staticRenderFns } from "./presentationProductMpago.vue?vue&type=template&id=2ae02c2e&"
import script from "./presentationProductMpago.vue?vue&type=script&lang=js&"
export * from "./presentationProductMpago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports